<template>
  <div>
    <div class="common-footer-wrap">
      <div class="common-footer">
        <div class="left">
          <img class="logo" src="../../assets/img2/pc/fzg-logo.png" alt="">
        </div>
        <div class="right">
          <div class="info">
            <div class="info-item">
              <div class="name">融资服务</div>
              <a class="email" href="mailto:bp@xfz.cn">bp@xfz.cn</a>
            </div>
            <div class="info-item">
              <div class="name">商务合作</div>
              <a class="email" href="mailto:bd@xfz.cn">bd@xfz.cn</a>
            </div>
            <div class="info-item">
              <div class="name">媒体合作</div>
              <a class="email" href="mailto:media@xfz.cn">media@xfz.cn</a>
            </div>
            <div class="info-item">
              <div class="name">简历投递</div>
              <a class="email" href="mailto:hr@xfz.cn">hr@xfz.cn</a>
            </div>
          </div>
          <div class="phone-area">
            <a class="phone" href="tel:010-85870086 "> 电话：010-85870086 </a>
            <a class="address" href="https://j.map.baidu.com/3e/8sf" target="_blank"> 地址：北京市朝阳区凤凰置地广场F座8层</a>

            <div class="wechat-line">
              <div class="wechat-item">
                <img class="wchat-icon" src="https://static-image.xfz.cn/1685923644886/wechat.png">
                <img class="wechat-qrcode" src="https://static-image.xfz.cn/1697973893660/pc-qr.jpg">
                <!-- <img class="wechat-qrcode" src="https://static-image.xfz.cn/1686010020225/wx-2-qr.jpg	"> -->
                <!-- <img class="wechat-qrcode" src="https://www.xfz.cn/static/build/images/xfz-wechat-share.png" > -->
              </div>
            </div>

          </div>
        </div>
      </div>
      <a v-show="scrollY > 200" href="#" class="return-top">返回顶部</a>
    </div>
    <div class="app-footer" :class="{'app-footer-mobile': !isPc(), 'app-footer-contact-page': isContactPage()}">
      <a href="https://beian.miit.gov.cn/" target="_blank"> 凡卓集团 COPY­RIGHT (©) 2023  沪ICP备18033374号-2 </a>
    </div>
  </div>
</template>


<style lang="scss">
.common-footer-wrap {
  background: #f2f1ee;
  height: 260px;
  padding-top: 30px;
  position: relative;
  .common-footer {
    // border: 1px solid red;
    width: 1150px;
    left: 50%;
    position: absolute;
    margin-left: -550px;
    font-size: 18px;
    .left {
      // border: 1px solid #333;
      display: inline-block;
      width: 340px;
      height: 200px;
      vertical-align: top;
      .logo {
        display: block;
        width: 220px;
        margin-left: 30px;
        margin-top: 70px;
      }
    }
    .right {
      // border: 1px solid #333;
      display: inline-block;
      width: 750px;
      height: 200px;
      vertical-align: top;
      .info {
        // border: 1px solid red;
        margin-top: 60px;
        .info-item {
          // border-right: 1px solid #ccc;
          // border: 1px solid #ccc;
          display: inline-block;
          font-size: 17px;
          padding-left: 40px;
          padding-right: 40px;
          position: relative;
          &::after {
            position: absolute;
            top: 4px;
            right: 0;
            border-right: 1px solid #ccc;
            height: 40px;
            content: " ";
          }
          &:last-child {
            &::after {
              display: none;
            }
          }
        }
      }
      .phone-area {
        // border: 1px solid #ccc;
        padding: 30px;
        .phone {
          margin-left: 10px;
          margin-right: 30px;
        }
        .wechat-line {
          // border: 1px solid red;
          display: inline-block;
          .wechat-item {
            display: inline-block;
            margin-left: 40px;
            position: relative;
            .wchat-icon {
              width: 30px;
              // border: 1px solid gray;
              margin-bottom: -8px;
            }
            .wechat-qrcode {
              transition: visibility 0s, opacity 0.5s linear;
              // display: none;
              visibility: hidden;
              opacity: 0;
              position: absolute;
              bottom: 40px;
              left: -170px;
              width: 385px;
              margin-top: 10px;
            }
            &:hover {
              .wechat-qrcode {
                opacity: 1;
                visibility: visible;
                // display: block;
              }
            }
          }
        }
      }
    }

  }
  .return-top {
    position: fixed;
    right: 40px;
    bottom: 60px;
    font-size: 14px;
    text-decoration: none;
    background: #ccc;
    width: 50px;
    aspect-ratio: 1;
    border-radius: 10px;
    font-size: 0;
    transition: visibility 1s, opacity 0.5s linear;
  }
  .return-top:before {
    content: "";
    position: absolute;
    inset: 35%;
    transform: translateY(20%) rotate(-45deg);
    border-top: 3px solid #fff;
    border-right: 3px solid #fff;
  }

  // .swiper-pagination-bullet {
  //   background-color: #DACAAB !important;
  // }
  // .swiper-pagination-bullet-active {
  //   background: #ffffff !important;
  // }
}
</style>


<script>
import util from '@/assets/js/util'

export default {
  data() {
    return {
      scrollY: 0,
    }
  },

  methods: {
    isPc() {
      return util.isPc()
    },
    isContactPage() {
      var path = this.$router.currentRoute.path
      return path.indexOf('/contact') > -1
    },
    onScroll(e) {
      this.scrollY = window.top.scrollY /* or: e.target.documentElement.scrollTop */
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll)
  },

}
</script>



// WEBPACK FOOTER //
// FooterPc.vue?1968b712